// import React, { useState, useEffect } from 'react';
// import './CSS/style.css';
// import './CSS/school wave.css';
// import './CSS/base theme.css';
// import './CSS/animate.css';
// import './CSS/fonts.css';
// import './CSS/jquery.css';
// import './CSS/upload theme.css';
// import './CSS/sprye.css';
// import './CSS/fancybax.css';

// const Header = () => {
//   // State to track the visibility and scroll position of the header
//   const [isScrolled, setIsScrolled] = useState(false);

//   // Effect to handle scroll events
//   useEffect(() => {
//     // Function to check scroll position
//     const handleScroll = () => {
//       if (window.scrollY > 100) {
//         setIsScrolled(true); // Change background to white when scrolled more than 100px
//       } else {
//         setIsScrolled(false); // Revert back when scrolled less than 100px
//       }
//     };

//     // Add the scroll event listener
//     window.addEventListener('scroll', handleScroll);

//     // Clean up the event listener when the component is unmounted
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   return (
//     <div class="page-template page-template-page-white-header page-template-page-white-header-php page page-id-7769 page-child parent-pageid-42 fl-builder fl-builder-2-8-6-1 fl-themer-1-4-11-2 fl-theme-1-7-18 tribe-no-js page-template-illuminate-2019-bb-child-theme fl-framework-base fl-preset-default fl-full-width wpb-js-composer js-comp-ver-7.3 vc_responsive" itemScope="itemScope" itemType="https://schema.org/WebPage">
// 		{/* // <!-- Google Tag Manager (noscript) snippet added by Site Kit --> */}
// 		<noscript>
// 			<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NDXJDNT" height="0" width="0" style="display:none;visibility:hidden"></iframe>
// 		</noscript>
// 		{/* // <!-- End Google Tag Manager (noscript) snippet added by Site Kit --> */}
// 		{/* // <!-- <a aria-label="Skip to content" class="fl-screen-reader-text" href="#fl-main-content">Skip to content</a> --> */}



// <div class="fl-page">
// 	<div id="header">
// 		<div class="fl-page-bar">
//     <div id="header" className={isScrolled ? 'header-scrolled' : 'header-visible'}>
//       {/* .fl-page-bar section */}


//       {/* Main Header */}
//       <header
//       className={`fl-page-header fl-page-header-primary fl-page-nav-right fl-page-nav-toggle-icon fl-page-nav-toggle-visible-mobile ${
//         isScrolled ? 'scrolled-header' : ''}`}
//       style={{
//         backgroundColor: isScrolled ? 'white' : '', // Set background color to white when scrolled
//         position: isScrolled ? 'fixed' : '', // Make header fixed when scrolled
//         top: isScrolled ? '0' : '', // Keep the header at the top
//         width: isScrolled ? '100%' : '', // Full width when scrolled
//         zIndex: '9999', // Ensure the header stays on top
//         boxShadow: isScrolled ? '0 4px 6px rgba(0, 0, 0, 0.1)' : '', // Add shadow to the header when fixed
//         transition: 'all 0.3s ease', // Smooth transition for background and position
//       }}
//     >
//       {/* Top Bar */}
//       <div className="fl-page-bar">
//         <div className="fl-page-bar-container container">
//           <div className="fl-page-bar-row row">
//             <div className="col-md-12 text-center clearfix">
//               <ul id="menu-top-navigation" className="fl-page-bar-nav nav navbar-nav menu">
//                 {/* <li id="menu-item-5036" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5036 nav-item">
//                   <a className="nav-link"><i className="fa fa-search"></i></a>
//                   <div id="searchform-inline" style={{ display: 'none' }}>
//                     <form role="form" action="/" method="get" name="searchform">
//                       <input type="text" name="s" className="search-query form-control" placeholder="Search" required="" />
//                       <button className="fa fa-search" type="submit"></button>
//                     </form>
//                   </div>
//                 </li> */}
//                 <li id="menu-item-4728" className="non-fastbridge menu-item menu-item-type-post_type menu-item-object-page menu-item-4728 nav-item">
//                   <a href="#" className="nav-link" style={{ color: isScrolled ? '#428bca' : '' }}>Contact</a>
//                 </li>
//                 <li id="menu-item-4730" className="non-fastbridge menu-item menu-item-type-post_type menu-item-object-page menu-item-4730 nav-item">
//                   <a href="#" className="nav-link" style={{ color: isScrolled ? '#428bca' : '' }}>Support</a>
//                 </li>
//                 <li id="menu-item-4941" className="btn non-fastbridge menu-item menu-item-type-post_type menu-item-object-page menu-item-4941 nav-item">
//                   <a href="/schoolwave/" className="nav-link">Log In</a>
//                 </li>
//                 <li id="menu-item-6655" className="btn non-fastbridge menu-item menu-item-type-custom menu-item-object-custom menu-item-6655 nav-item">
//                   <a href="#" className="nav-link" >Get a demo</a>
//                 </li>
//                 <li id="menu-item-6655" className="btn non-fastbridge menu-item menu-item-type-custom menu-item-object-custom menu-item-6655 nav-item">
//                   <a href="/camp" className="nav-link" >Masterclass</a>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Search */}
//       <div className="visible-xs">
//         <div id="searchform-mobile" style={{ display: 'none' }}>
//           <form role="form" action="/" method="get" name="searchform">
//             <input type="text" name="s" className="search-query form-control" placeholder="Search" required="" />
//             <button className="fa fa-search" type="submit"></button>
//           </form>
//         </div>
//       </div>

//       {/* Main Header */}
//       <div className="fl-page-header-wrap">
//         <div className="fl-page-header-container container">
//           <div className="fl-page-header-row row">
//             <div className="fl-page-header-logo-col">
//               <div className="fl-page-header-logo" itemScope="itemScope" itemType="https://schema.org/Organization">
//                 <a href="#" itemProp="url">
//                   <img
//                     src={isScrolled ? '/School Wave Logocolor.png' : '/schoolwavelogowhitecolor.png'}
//                     className={`logo`}
//                     height="100px"
//                     alt="Logo"
//                   />
//                 </a>
//               </div>
//             </div>
//             {/* <div className="fl-page-nav-col">
//               <div className="fl-page-nav-wrap">
//                 <nav className="fl-page-nav fl-nav navbar navbar-default navbar-expand-md" aria-label="Header Menu" itemScope="itemScope" itemType="https://schema.org/SiteNavigationElement">
//                   <span className="navbar-toggle-new navbar-toggler-new" data-toggle="collapse" data-target=".fl-page-nav-collapse-new">
//                     <span>
//                       <i className="fas fa-bars" aria-hidden="true"></i>
//                       <span className="sr-only">Menu</span>
//                     </span>
//                   </span>
//                   <div className="fl-page-nav-collapse-new navbar-collapse-new">
//                     <ul id="menu-main-nav" className="nav navbar-nav navbar-right menu">
//                       <li id="menu-item-14335" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-14335 nav-item">
//                         <a href="#" className="nav-link" style={{ color: isScrolled ? '#428bca' : '' }}>Why School Wave</a>
//                       </li>
//                       <li id="menu-item-7623" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7623 nav-item">
//                         <a href="#" className="nav-link" style={{ color: isScrolled ? '#428bca' : '' }}>Solutions</a>
//                       </li>
//                       <li id="menu-item-5206" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5206 nav-item">
//                         <a href="#" className="nav-link" style={{ color: isScrolled ? '#428bca' : '' }}>Products</a>
//                       </li>
//                       <li id="menu-item-15029" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-15029 nav-item">
//                         <a href="#" className="nav-link" style={{ color: isScrolled ? '#428bca' : '' }}>Resources</a>
//                       </li>
//                       <li id="menu-item-14492" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-14492 nav-item">
//                         <a href="#" className="nav-link" style={{ color: isScrolled ? '#428bca' : '' }}>Research</a>
//                       </li>
//                       <li id="menu-item-5474" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5474 nav-item">
//                         <a href="#" className="nav-link" style={{ color: isScrolled ? '#428bca' : '' }}>About</a>
//                       </li>
//                     </ul>
//                   </div>
//                 </nav>
//               </div>
//             </div> */}
//           </div>
//         </div>
//       </div>
//     </header>
//     </div>
//     </div>
//     </div>
//     </div>
//     </div>
//   );
// };

// export default Header;



import React, { useState, useEffect } from 'react';
import './CSS/style.css';
import './CSS/school wave.css';
import './CSS/base theme.css';
import './CSS/animate.css';
import './CSS/fonts.css';
import './CSS/jquery.css';
import './CSS/upload theme.css';
import './CSS/sprye.css';
import './CSS/fancybax.css';
import { Margin } from '@mui/icons-material';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 80);
    };

    document.body.addEventListener("scroll", handleScroll);
    return () => document.body.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`main-header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">


        <div className="logo">
          <img src={
            isScrolled
              ? "/School Wave Logocolor.png"
              : "/schoolwavelogowhitecolor.png"
          }
            alt="Logo"
          />
        </div>

        <div className='navbar-1'>
          <nav className={`nav-menu ${menuOpen ? "active" : ""}`}>
            <div className='nav-column-top'>
              <a href="#footer-section" onClick={(e) => {
                e.preventDefault();
                const footer = document.getElementById("footer-section");
                if (footer) {
                  document.body.scrollTo({
                    top: footer.offsetTop,
                    behavior: "smooth",
                  });
                }
              }}
              >Contact</a>

              {/* <a href="/SupportForm" className="" style={{ marginTop: "15px" }}>Support</a> */}
              <a href="/schoolwave/" className="demo-btn">Log In</a>
              <a href="#" className="demo-btn">Get a Demo</a>
              <a href="https://www.technotharanga.com/masterclass/masterclass.html" target='blank' className="demo-btn-1">Masterclass</a>
            </div>

            <div className='nav-column-bottom'>
              <a href="#">Why SchoolWave</a>
              <a href="#">Research</a>
              <a href="#">Solutions</a>

              <div className="nav-dropdown">
                <a href="#">Products</a>
                <div className="nav-dropdown-content">
                  <a href="/mobile">Mobile App</a>
                </div>
              </div>

              <div className="nav-dropdown">
                <a href="#">Programs</a>
                <div className="nav-dropdown-content">
                  <a href="https://www.technotharanga.com/masterclass/masterclass.html" target='blank'>Masterclass</a>
                </div>
              </div>

              <a href="#">About</a>
            </div>
          </nav>
        </div>

        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>
    </header>
  );
};

export default Header;